import React, {Component} from 'react';
import TextInput from '../components/TextInput';
import FuelerIcon from '../components/FuelerIcon';
import Flex from '../components/Flex';
import Text from '../components/Text';
import Button from '../components/Button';
import {erValidation} from '../lib';

const FormContainer = Flex.extend `
    margin-top: 12px;
    align-items: center;
    justify-content: space-between;
    @media (min-width: 768px) {
        justify-content: flex-start;
    }
    width: 100%;
    flex: 1;
`;

const Wrapper = Flex.extend `
    align-items: center;
    width: 80%;
    @media (min-width: 768px) {
        width: 50%;
    }
    margin: 8px 45px;
`;

const ButtonRow = Flex.extend `
    width: 75%;
    @media (min-width: 768px) {
        width: 50%;
    }
    justify-content: center;
    margin-bottom: 30px;
`;

const LogButton = Button.extend `
    justify-content: center;
    display: flex;
    flex: 1;
`;

class FuelForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                fuelVolume: {
                    value: props.formData.fuelVolume,
                    valid: true,
                    validate: erValidation.decimal
                },
                DEFVolume: {
                    value: props.formData.DEFVolume,
                    valid: true,
                    validate: erValidation.decimal
                },
                odometer: {
                    value: props.formData.odometer,
                    valid: true,
                    validate: erValidation.decimal
                },
                cost: {
                    value: props.formData.cost,
                    valid: true,
                    validate: erValidation.decimal
                },
                apparatusHours: {
                    value: props.formData.apparatusHours,
                    valid: true,
                    validate: erValidation.decimal
                },
                notes: {
                    value: props.formData.notes,
                    valid: true,
                    validate: () => {
                        return true;
                    }
                }
            },
            submitting: false
        }

        this.onFormChange = this
            .onFormChange
            .bind(this);
        this.validateForm = this
            .validateForm
            .bind(this);
        this.validation = erValidation;
    };

    onFormChange(event) {
        var form = Object.assign({}, this.state.form);
        var key = event.target.name;
        var value = event.target.value;
        var validate = form[key].validate;
        var valid = validate(value.replace(/,/g, ''));

        form[key] = {
            value,
            valid,
            validate
        }

        this.setState({form});
    };

    componentWillUnmount() {
        if (this.tid) {
            clearTimeout(this.tid);
        }
    }

    validateForm() {
        this.setState({submitting: true});

        let form = this.state.form;
        let isValid = Object
            .keys(form)
            .reduce((isValid, key) => {
                return isValid && form[key].valid;
            }, true);

        if (!isValid) {
            this.tid = setTimeout(() => {
                this.setState({submitting: false});
            }, 3000);
        } else {
            isValid && this
                .props
                .onSubmit(this.state.form);
        }
    }

    render() {
        const {form, submitting} = this.state;
        const {onFocus} = this.props;
        const numericError = 'This field must be numeric';
        const inputProps = {
            height: '36px',
            onChange: this.onFormChange,
            submitting: submitting,
            onFocus: onFocus,
            maxLength: 9,
            type: 'number'
        };

        return (
            <FormContainer column>
                <Wrapper column>
                    <TextInput
                        name="fuelVolume"
                        label="Fuel Volume"
                        value={form.fuelVolume.value}
                        valid={form.fuelVolume.valid}
                        errorMessage={numericError}
                        min="0"
                        {...inputProps}/>
                    <TextInput
                        name="DEFVolume"
                        label="DEF Volume"
                        value={form.DEFVolume.value}
                        valid={form.DEFVolume.valid}
                        errorMessage={numericError}
                        min="0"
                        {...inputProps}/>
                    <TextInput
                        name="odometer"
                        label="Odometer"
                        value={form.odometer.value}
                        valid={form.odometer.valid}
                        errorMessage={numericError}
                        min="0"
                        {...inputProps}/>
                    <TextInput
                        name="apparatusHours"
                        label="Apparatus Hours"
                        value={form.apparatusHours.value}
                        valid={form.apparatusHours.valid}
                        errorMessage={numericError}
                        min="0"
                        {...inputProps}/>
                    <TextInput
                        name="cost"
                        label="Cost"
                        value={form.cost.value}
                        valid={form.cost.valid}
                        errorMessage={numericError}
                        min="0"
                        {...inputProps}/>
                    <TextInput
                        name="notes"
                        label="Notes"
                        textArea
                        value={form.notes.value}
                        valid={form.notes.valid}
                        {...inputProps}
                        height='75px'
                        type='text'/>
                </Wrapper>
                <ButtonRow>
                    <LogButton primary onClick={this.validateForm} width="100%">
                        <FuelerIcon icon="check" fill="white" size="40px"/>
                        <Text fontWeight="600">Log Fuel Usage</Text>
                    </LogButton>
                </ButtonRow>
            </FormContainer>
        );
    }
}

export default FuelForm;


// WEBPACK FOOTER //
// ./src/ApparatusFuel/FuelForm.js